export enum ButtonState {
    Initialized,
    Pending,
    Succeeded,
    Failed,
}
